import { spacing } from "@indeed/ifl-tokens/react-native";
import { useWindowDimensions } from "react-native";

const PAGE_GUTTER = spacing.s4;

/**
 * Largest a starter chip may get before its label ellipsizes.
 *
 * The chips live in a horizontal track: bleeding mounts pull the scroller back
 * to the screen edges and re-inset the first chip by `bleedInset`, while
 * non-bleeding mounts sit inside both page gutters. Capping at the visible
 * track keeps a long label from running past the trailing edge — a chip wider
 * than the screen would force the reader to drag horizontally just to finish
 * one question.
 */
export const useStarterChipMaxWidth = (bleedInset: number): number => {
  const { width } = useWindowDimensions();

  // Clamped so a not-yet-measured (or absurdly small) width can't go negative,
  // matching PostApplyAd's cardWidth (RN-6592).
  return Math.max(width - (bleedInset > 0 ? bleedInset : PAGE_GUTTER * 2), 0);
};
